export default __webpack_public_path__ + "static/media/grass_cutting.aa9bac96.jpg";